var _path, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQueenBedIconKlm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "ic_bed_queen"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    d: "M10.6667 3.66634V1.66634C10.6667 0.929961 10.0697 0.333008 9.33333 0.333008H2.66667C1.93029 0.333008 1.33333 0.929961 1.33333 1.66634V3.66634C0.596954 3.66634 0 4.26329 0 4.99967V8.33301H0.886667L1.33333 9.66634H2L2.44667 8.33301H9.55333L10 9.66634H10.6667L11.1133 8.33301H12V4.99967C12 4.26329 11.403 3.66634 10.6667 3.66634ZM9.33333 3.66634H2.66667V1.66634H9.33333V3.66634Z",
    fill: "#00A1DE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_421_4204",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 10
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.6667 3.66634V1.66634C10.6667 0.929961 10.0697 0.333008 9.33333 0.333008H2.66667C1.93029 0.333008 1.33333 0.929961 1.33333 1.66634V3.66634C0.596954 3.66634 0 4.26329 0 4.99967V8.33301H0.886667L1.33333 9.66634H2L2.44667 8.33301H9.55333L10 9.66634H10.6667L11.1133 8.33301H12V4.99967C12 4.26329 11.403 3.66634 10.6667 3.66634ZM9.33333 3.66634H2.66667V1.66634H9.33333V3.66634Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_421_4204)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\x8E\xA8-Color"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Black",
    d: "M22.6668 -11.667H-10.6665V21.6663H22.6668V-11.667Z",
    fill: "#00A1DE"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueenBedIconKlm);
export default __webpack_public_path__ + "static/media/queen-bed-icon-klm.33dd58765e33dd285a4e6e2ce5e571b4.svg";
export { ForwardRef as ReactComponent };